import { render } from "./CurrentVersion.vue?vue&type=template&id=93faa2dc"
import script from "./CurrentVersion.vue?vue&type=script&lang=js"
export * from "./CurrentVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__